exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".text-show-modal-body \n{\n    word-break: break-word;\n    overflow-y: scroll;\n}", ""]);

